import { render, staticRenderFns } from "./BankAddEdit.vue?vue&type=template&id=42744ba0"
import script from "./BankAddEdit.vue?vue&type=script&lang=js"
export * from "./BankAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports